import { apiServer } from "common/config";
import { Team, UserAccountPreference } from "../types/team";
import { fetchWithToken } from "./fetchWithToken";

interface SyncTeamsResponse {
  status: string;
  message: string;
  data: {
    member_of_teams: Team[];
    user_teams: Team[];
    account_preferences: UserAccountPreference[];
  };
}

export async function syncTeams(token: string) {
  console.log("Getting teams");
  const response = await fetchWithToken(`${apiServer + "/user/sync-teams"}`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return (await response.json()) as SyncTeamsResponse;
}

export async function createTeam(token: string, teamName: string) {
  const formData = new FormData();
  formData.append("team_name", teamName);
  formData.append("team_photo", null as any);
  const response = await fetchWithToken(`${apiServer + "/user/create-team"}`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });
  return await response.json();
}

export async function updateTeam(
  token: string,
  teamId: string,
  teamName: string,
  teamPhoto?: string
) {
  const formData = new FormData();
  formData.append("team_id", teamId);
  formData.append("team_name", teamName);
  if (teamPhoto) {
    const fileName = `team_photo.jpg`;
    const file = {
      uri: teamPhoto,
      type: "image/jpeg",
      name: fileName,
    };
    formData.append(`team_photo`, file as any, fileName);
  }
  const response = await fetchWithToken(`${apiServer + "/user/update-team"}`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });
  return await response.json();
}

export async function deleteTeam(token: string, teamId: string) {
  const formData = new FormData();
  formData.append("team_id", teamId);
  const response = await fetchWithToken(`${apiServer + "/user/remove-team"}`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });
  return await response.json();
}

export async function addUserToTeam(token: string, inviteCode: string) {
  const formData = new FormData();
  formData.append("team_share_link", inviteCode);
  const response = await fetchWithToken(`${apiServer + "/user/process-invite"}`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });
  return await response.json();
}

export async function getTeamUserTeams(
  token: string,
  teamUserId: string,
  userId: string
) {
  const response = await fetchWithToken(
    `${apiServer + "/user/public-teams/" + teamUserId + "/" + userId}`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return (await response.json()) as SyncTeamsResponse;
}

export async function removeUserFromTeam(
  teamId: string,
  userId: string,
  accessToken: string
) {
  const formData = new FormData();
  formData.append("team_id", teamId);
  formData.append("user_id", userId);
  const response = await fetchWithToken(`${apiServer + "/user/remove-user-from-team"}`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    body: formData,
  });
  return await response.json();
}

export async function leaveTeam(teamId: number, accessToken: string) {
  const formData = new FormData();
  formData.append("team_id", teamId.toString());
  const response = await fetchWithToken(`${apiServer + "/user/leave-team"}`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    body: formData,
  });
  return await response.json();
}
